import type { Dispatch, SetStateAction } from 'react';

import type { AdcampaignPlaybackReportTypeForInput } from '@shared/api/graphql/generated';

import type { ReportRecipientType } from './ReportRecipientsSelect/types';

export const AUDIO_REPORT_SCOPE = {
  COMMON: 'common',
  ADDRESSES: 'addresses',
  PROMOS: 'promos',
} as const;

export type AudioReportScopeType = (typeof AUDIO_REPORT_SCOPE)[keyof typeof AUDIO_REPORT_SCOPE];

export const PROMO_SELECTOR_LAYOUT = {
  EXPANDED: 'expanded',
  SINGLE_RESULT: 'single-result',
  EMPTY: 'empty',
} as const;

export type PromoSelectorLayout = (typeof PROMO_SELECTOR_LAYOUT)[keyof typeof PROMO_SELECTOR_LAYOUT];

export type ReportAddressTagType = {
  id: string;
  title: string;
};

export type ReportAddressType = {
  id: string;
  address: string;
  comment?: string;
  tags: ReportAddressTagType[];
};

export interface RequestAdCampaignsReportModalProps {
  refetchReports: () => void;
  adcampaignReportType: AdcampaignPlaybackReportTypeForInput;
}

export type DateRangeChangeHandler = (startDate: Date | null, endDate: Date | null) => void;

type BaseAdCampaignsReportModalProps = {
  close: () => void;
  closeButtonText: string;
  endDate: Date | null;
  isMobile: boolean;
  isRequestDisabled: boolean;
  loading: boolean;
  modalTitle: string;
  onDateRangeChange: DateRangeChangeHandler;
  onRequestSubmit: () => void;
  requestButtonText: string;
  startDate: Date | null;
};

export type DefaultAdCampaignsReportModalProps = BaseAdCampaignsReportModalProps;

export type AudioAdCampaignsReportModalProps = BaseAdCampaignsReportModalProps & {
  externalRecipientEmails: string[];
  isExternalRecipientsInputVisible: boolean;
  isPromoDraftLoading: boolean;
  isReportAddressesLoading: boolean;
  onExternalRecipientEmailsChange: (emails: string[]) => void;
  onModalClose: () => void;
  onReportScopeChange: (scope: AudioReportScopeType) => void;
  onRetryPromoDraftCreate: () => void;
  onSelectedAddressIdsChange: (addressIds: string[]) => void;
  onSelectedRecipientIdsChange: (recipientIds: string[]) => void;
  onShowExternalRecipientsInput: () => void;
  recipients: ReportRecipientType[];
  reportAddresses: ReportAddressType[];
  reportAddressTags: ReportAddressTagType[];
  reportScope: AudioReportScopeType;
  promoDraftError: Error | undefined;
  promoDraftId: string | undefined;
  promoTotalCount: number;
  selectedAddressIds: string[];
  selectedPromoCount: number;
  selectedRecipientIds: string[];
  setSelectedPromoCount: Dispatch<SetStateAction<number>>;
};
